import { Box, Text } from "@wix/design-system";
import React from "react";
const Section = ({
  children,
  title
}) => {
  return /* @__PURE__ */ React.createElement(Box, { direction: "vertical" }, /* @__PURE__ */ React.createElement(Box, { marginBottom: "SP4" }, /* @__PURE__ */ React.createElement(Text, { size: "small", weight: "bold" }, title)), /* @__PURE__ */ React.createElement(Box, { direction: "vertical", gap: "SP3" }, children));
};
export {
  Section
};
//# sourceMappingURL=section.js.map
